/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { JsmCustomerAuthenticationSettingsResponse } from './JsmCustomerAuthenticationSettingsResponse.types.tsx';

const RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS = 'JSM_CUSTOMER_AUTHENTICATION_SETTINGS';

const ONE_DAY_IN_MILLIS: number = 1000 * 60 * 60 * 24;

export const jsmCustomerAuthenticationSettingsResource: RouteResource<JsmCustomerAuthenticationSettingsResponse> =
	createResource<JsmCustomerAuthenticationSettingsResponse>({
		type: RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS,
		getKey: () => 'settings',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-jsm-customer-authentication-settings", jiraSpaEntry: "async-resource-jsm-customer-authentication-settings" */ './getData.tsx'
			),
		maxAge: ONE_DAY_IN_MILLIS,
	});
